CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
SavedSearch = require 'models/saved-search'
Util = require 'lib/util'

module.exports = class SavedSearchList extends CollectionWithHelpers
  model: SavedSearch
  url: -> "/1/member/#{ @member.id }/savedSearches"

  initialize: (list, { @member }) ->
    @listenTo @, 'change:pos', @sort

  comparator: (savedSearch) -> savedSearch.get('pos') || 0

  saveSearch: (name, query) ->
    if @length
      pos = @at(@length - 1).get('pos') + Util.spacing
    else
      pos = Util.spacing

    @create
      name: name
      query: query
      pos: pos
    , { @modelCache }



// WEBPACK FOOTER //
// ./app/scripts/models/collections/saved-search-list.coffee